export enum IntermediaryConfigurationActionType {
  DownloadApiRequestTemplate = 'intermediaryConfiguration/downloadApiRequestTemplate',
  DownloadApiRequestTemplateSuccess = 'intermediaryConfiguration/downloadApiRequestTemplateSuccess',
  DownloadApiRequestTemplateFailure = 'intermediaryConfiguration/downloadApiRequestTemplateFailure',
}
